import { FileAddOutlined, FolderOpenOutlined, PlayCircleOutlined } from '@ant-design/icons';

import MenuConfigType from '@app/types/MenuConfigType';

export const documentMaintenanceMenuConfig: MenuConfigType = {
  path: '/document-maintenance/z',
  title: 'Document Maintenance',
  key: 'DocumentMaintenance',
  icon: FolderOpenOutlined,
  guard: [],
  children: [
    {
      path: '/document-maintenance/auto-filing-setting',
      title: 'AutoFiling Settings',
      key: 'AutoFilingSettings',
      icon: PlayCircleOutlined,
      guard: [],
    },
    {
      path: '/document-maintenance/bulk-document-creation',
      title: 'Bulk Document Creation',
      key: 'BulkDocumentCreation',
      icon: FileAddOutlined,
      guard: [],
      privileged: true,
      featureFlag: 'bulkDocumentCreation',
    },
  ],
};

export default documentMaintenanceMenuConfig;
